<script setup lang="ts">
import type { ApiCustomerGetAll, ApiMachineryGetById } from '~/types'

export interface ChangeMachineryCustomer {
  data: ApiMachineryGetById
  customers?: ApiCustomerGetAll[]
}

type MachineryWithOldCustomerIdField = ApiMachineryGetById & { oldCustomerId: string | null }

const props = defineProps<{
  payload: ChangeMachineryCustomer
}>()

const emit = defineEmits<{ (e: 'save', data: MachineryWithOldCustomerIdField): void }>()

const customerOptions = computed(() => props.payload.customers?.map(customer => ({
  label: customer.name,
  value: customer.id,
})) ?? [])

function submit({ foreignMachineryCustomerId }: { foreignMachineryCustomerId: string }) {
  emit('save', {
    ...props.payload.data,
    oldCustomerId: props.payload.data.foreignMachineryCustomerId,
    foreignMachineryCustomerId,
    isReleasedForRent: false,
    isForeignReleasedForRent: false,
  })
}
</script>

<template>
  <FormKit :value="{ foreignMachineryCustomerId: payload.data.foreignMachineryCustomerId }" :submit-label="$t('button.save')" type="form" @submit="submit">
    <FormKitMultiSelect
      name="foreignMachineryCustomerId"
      :is-multi-select-allowed="false"
      :multi-select-options="customerOptions"
      :label="$t('customer.name', { count: 1 })"
      validation="required"
    />
  </formkit>
</template>
